/**
 * 文案促销机动版块
 */
import './index.less';
import { getServerTime } from '@utils/api.js';
class ProductTextPromotion {
  constructor() {
    // 获取 文案促销 DOM
    this.DOM = document.querySelector('#app-text-promotion');
    if (!this.DOM || this.DOM.length === 0) return;

    const {
      shopifyTimeStr, endsInText,
      countdownStartStr, countdownEndStr, countdownLabelStr = '', countdownTextColor,
      countdownBgColor, countdownNumberColor,
    } = this.DOM.dataset;

    this.i18nText = {
      endsInText,
      countdownLabel: countdownLabelStr?.split(','),
      countdownTextColor,
      countdownBgColor,
      countdownNumberColor,
    };

    const currentTime = new Date(shopifyTimeStr).getTime();
    this.startTime = new Date(countdownStartStr || 0).getTime();
    this.endTime = new Date(countdownEndStr || 0).getTime();

    this.countdownStatus = this.checkCountDownStatus(currentTime, this.startTime, this.endTime);
    if (this.countdownStatus) {
      this.initCountDownDOM();

      // 开始倒计时
      this.tick(currentTime, this.endTime);

      // 监听tab页签或窗口激活状态，重新刷新倒计时
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      window.addEventListener('focus', this.handleWindowFocus);
    }
  }

  // 判断倒计时状态
  checkCountDownStatus(currentTime, startTime, endTime) {
    let flag = false;
    if (!startTime && endTime) {
      // 只有结束时间，判断当前时间是否小于结束时间
      if (currentTime < endTime) {
        flag = true;
      } else {
        flag = false;
      }
    } else if (startTime && endTime) {
      // 有开始时间和结束时间，则判断当前时间在不在开始时间和结束时间之间
      if (currentTime >= startTime && currentTime < endTime) {
        flag = true;
      } else {
        flag = false;
      }
    } else {
      // 只有开始时间，不展示UI
      flag = false;
    }
    return flag;
  }

  // 渲染倒计时DOM
  initCountDownDOM() {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = this.renderCountDownDOM();
    this.DOM.append(...tempDiv.children);

    // 倒计时 DOM
    this.daysDOM = this.DOM.querySelector('[data-countdown-days]');
    this.hrsDOM = this.DOM.querySelector('[data-countdown-hrs]');
    this.minsDOM = this.DOM.querySelector('[data-countdown-mins]');
    this.secsDOM = this.DOM.querySelector('[data-countdown-secs]');
  }

  // 倒计时计数
  tick(currentTime, endTime) {
    const leftTime = (endTime - currentTime) / 1000;
    let days, hours, minutes, seconds;

    if (leftTime <= 0) {
      this.timer && clearTimeout(this.timer);

      // 移除倒计时DOM
      this.DOM.querySelector('.text-promotion-countdown').remove();
    } else {
      days = String(parseInt(leftTime / 60 / 60 / 24)).padStart(2, '0');
      hours = String(parseInt(leftTime / 60 / 60 % 24)).padStart(2, '0');
      minutes = String(parseInt(leftTime / 60 % 60)).padStart(2, '0');
      seconds = String(parseInt(leftTime % 60)).padStart(2, '0');

      this.daysDOM.innerText = days;
      this.hrsDOM.innerText = hours;
      this.minsDOM.innerText = minutes;
      this.secsDOM.innerText = seconds;

      this.timer = setTimeout(() => this.tick(currentTime + 1000, endTime), 1000);
    }
  }

  // 渲染 富文本
  renderCountDownDOM() {
    const daysItem = this.renderTimeItem('days', this.i18nText.countdownLabel[0] || '');
    const HrsItem = this.renderTimeItem('hrs', this.i18nText.countdownLabel[1] || '');
    const MinsItem = this.renderTimeItem('mins', this.i18nText.countdownLabel[2] || '');
    const secsItem = this.renderTimeItem('secs', this.i18nText.countdownLabel[3] || '');

    return `
      <div class="text-promotion-countdown flex items-start mt-24 lg:j-mt-8 xl:a-mt-8">
        <div
          class="font-normal text-26 mr-16 leading-56 lg:j-text-14 lg:j-mr-12 lg:j-leading-28 xl:a-text-14 xl:a-mr-12 xl:a-leading-28"
          style="color:${this.i18nText.countdownTextColor}"
        >${this.i18nText.endsInText}</div>
        <div class="flex flex-col">
          <div class="flex items-start justify-center">
            ${daysItem}
            <span
              class="flex-center font-semibold w-50 h-50 text-36 lg:j-w-25 lg:j-h-26 lg:j-text-18 xl:a-w-25 xl:a-h-26 xl:a-text-18"
              style="color:${this.i18nText.countdownBgColor}"
            >:</span>
            ${HrsItem}
            <span
              class="flex-center font-semibold w-50 h-50 text-36 lg:j-w-25 lg:j-h-26 lg:j-text-18 xl:a-w-25 xl:a-h-26 xl:a-text-18"
              style="color:${this.i18nText.countdownBgColor}"
            >:</span>
            ${MinsItem}
            <span
              class="flex-center font-semibold w-50 h-50 text-36 lg:j-w-25 lg:j-h-26 lg:j-text-18 xl:a-w-25 xl:a-h-26 xl:a-text-18"
              style="color:${this.i18nText.countdownBgColor}"
            >:</span>
            ${secsItem}
          </div>
        </div>
      </div>`;
  }

  // 渲染单个的 item
  renderTimeItem(name, label) {
    return `
      <div class="flex-center flex-col gap-y-4 lg:j-gap-y-2 xl:a-gap-y-2">
        <span
          class="flex-center font-medium leading-normal min-w-60 h-56 rounded-8 text-30 px-10 lg:j-min-w-30 lg:j-h-28 lg:j-rounded-5 lg:j-text-16 lg:j-px-5 xl:a-min-w-30 xl:a-h-28 xl:a-rounded-5 xl:a-text-16 xl:a-px-5"
          style="color:${this.i18nText.countdownNumberColor};background-color:${this.i18nText.countdownBgColor}"
          data-countdown-${name}
        ></span>
        ${label ? `
            <span
              class="font-normal text-22 lg:j-text-10 xl:a-text-10"
              style="color:${this.i18nText.countdownTextColor}"
            >${label}</span>
          ` : ''
      }
      </div>
    `;
  }

  // 监听页面可见性（页面激活：标签页切换回来）
  handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      this.resumeActivities();
    }
  };

  // 监听窗口焦点（整个浏览器窗口 窗口激活）
  handleWindowFocus = () => {
    this.resumeActivities();
  };

  // 获取服务器时间
  async fetchServerTime() {
    const { data, } = await getServerTime();
    const serverTime = new Date(data.datetime).getTime();
    this.countdownStatus = this.checkCountDownStatus(serverTime, this.startTime, this.endTime);

    // 移除倒计时DOM
    this.DOM.querySelector('.text-promotion-countdown').remove();

    if (this.countdownStatus) {
      // 初始化倒计时DOM
      this.initCountDownDOM();

      // 开始倒计时
      clearTimeout(this.timer);
      this.tick(serverTime, this.endTime);
    } else {
      this.destroy();
    }
  }

  resumeActivities = () => {
    // 确保当前的倒计时是有效的，然后再统一处理激活状态逻辑
    if (this.countdownStatus) {
      this.fetchServerTime();
    }
  };

  // 建议添加清理方法
  destroy() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    window.removeEventListener('focus', this.handleWindowFocus);
  }
}

let textPromotionInstance = null;
document.addEventListener('DOMContentLoaded', () => {
  textPromotionInstance = new ProductTextPromotion();
});

// 页面卸载时清理
window.addEventListener('beforeunload', () => {
  if (textPromotionInstance) {
    textPromotionInstance.destroy();
    textPromotionInstance = null;
  }
});